import { cn } from "@/lib/utils"
import { ThemeToggle } from "@/components/theme-toggle"
import { BookGridSkeleton } from "@/components/ui/book-card-skeleton"
import { DotPattern } from "@/components/ui/dot-pattern"
import { Logo } from "@/components/ui/logo"
import { ChatwootWidget } from "@/components/ui/chatwoot-widget"


interface DashboardSkeletonProps {
  className?: string
}

export function DashboardSkeleton({ className }: DashboardSkeletonProps) {
  return (
    <div className={cn("min-h-screen bg-background relative overflow-hidden", className)}>
      {/* Background Pattern */}
      <DotPattern
        className={cn(
          "[mask-image:radial-gradient(800px_circle_at_center,white,transparent)]",
          "fixed inset-0 h-full w-full opacity-20 dark:opacity-50"
        )}
      />

      {/* Header Skeleton */}
      <header className="relative z-10 border-b border-border/50 bg-background/95 backdrop-blur-sm">
        <div className="container mx-auto px-4 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="h-8 xs:h-9 sm:h-10">
                <Logo className="h-8 xs:h-9 sm:h-10 mx-0" />
              </div>
              <div>
                <h1 className="text-lg sm:text-xl">Sabhia - HUB</h1>
                <div className="h-3 xs:h-4 w-40 xs:w-48 bg-muted rounded animate-pulse mt-1" />
              </div>
            </div>

            <div className="flex items-center gap-4">
              <ThemeToggle />
              <div className="h-8 w-12 xs:w-14 sm:w-16 bg-muted rounded-lg animate-pulse" />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content Skeleton */}
      <main className="relative z-10 container mx-auto px-4 py-6 sm:py-8">
        <div className="mb-6 flex items-center justify-between">
          <div className="h-6 w-40 sm:w-48 bg-muted rounded animate-pulse" />
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 rounded-full bg-muted animate-pulse" />
            <div className="h-4 w-24 bg-muted rounded animate-pulse" />
          </div>
        </div>

        {/* Grid de livros skeleton */}
        <BookGridSkeleton count={6} className="gap-4 sm:gap-6" />
      </main>

      {/* WhatsApp Float (parity with real dashboard) */}
      <ChatwootWidget />
    </div>
  )
}
